import { AuthCard } from "./AuthCard";

/**
 * 앱 초기화 splash 다. 로그인/콜백과 같은 `AuthCard` 로 그린다. 그래서 부트부터 로그인까지
 * 카드 프레임은 유지되고 내용만 바뀐다. 카드가 깜빡이며 나타났다 사라지지 않는다.
 */
export function AppSplash() {
  return (
    <AuthCard status={{ kind: "pending", message: "Hatchery Registry를 시작하고 있습니다." }} />
  );
}
